import { render, staticRenderFns } from "./stockLossHistory.vue?vue&type=template&id=5e5258ec&scoped=true"
import script from "./stockLossHistory.vue?vue&type=script&lang=js"
export * from "./stockLossHistory.vue?vue&type=script&lang=js"
import style0 from "./stockLossHistory.vue?vue&type=style&index=0&id=5e5258ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5258ec",
  null
  
)

export default component.exports